import React, { useCallback, useMemo, useState } from 'react';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { TextField } from '@mui/material';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { EditRubricCard } from 'apps/sigma2-ui/src/components/rubrics/EditRubricCard';
import { TertiaryButton } from 'apps/sigma2-ui/src/components/TertiaryButton';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';
import { TouchTargetProps } from 'apps/sigma2-ui/src/components/ui/TouchTarget';
import { EditRubricSaveButton } from 'apps/sigma2-ui/src/components/rubrics/EditRubricSaveButton';
import { EditRubricCancelButton } from 'apps/sigma2-ui/src/components/rubrics/EditRubricCancelButton';
import { EditRubricAddCriteriaButton } from 'apps/sigma2-ui/src/components/rubrics/EditRubricAddCriteriaButton';
import { EditRubricTagsPopup } from 'apps/sigma2-ui/src/components/rubrics/EditRubricTagsPopup';
import cn from 'classnames';
import { RubricTagPill } from 'apps/sigma2-ui/src/components/rubrics/RubricTagPill';
import { EditRubricEditCategorySectionCriteriaThread } from 'apps/sigma2-ui/src/components/rubrics/EditRubricEditCategorySectionCriteriaThread';
import { RubricGradingType } from 'libs/end-to-end/src/types/rubrics/rubric';

const EditRubricEditCategorySectionAddTagButtonIcon: React.FC<SvgProps> = (
  props,
) => {
  const fillColor = toSvgColor('currentColor', props);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g>
        <path
          d="M15.6641 6C15.6641 6.39782 15.8221 6.77936 16.1034 7.06066C16.3847 7.34196 16.7662 7.5 17.1641 7.5C17.5619 7.5 17.9434 7.34196 18.2247 7.06066C18.506 6.77936 18.6641 6.39782 18.6641 6C18.6641 5.60218 18.506 5.22064 18.2247 4.93934C17.9434 4.65804 17.5619 4.5 17.1641 4.5C16.7662 4.5 16.3847 4.65804 16.1034 4.93934C15.8221 5.22064 15.6641 5.60218 15.6641 6Z"
          fill={fillColor}
        />
        <path
          d="M9.89736 21.19C9.86752 21.1349 9.81806 21.093 9.7588 21.0726C9.69953 21.0523 9.63478 21.0549 9.57736 21.08C9.39247 21.1644 9.18624 21.1905 8.98615 21.1548C8.78605 21.1191 8.6016 21.0232 8.45736 20.88L2.28736 14.71C2.19363 14.617 2.11924 14.5064 2.06847 14.3846C2.0177 14.2627 1.99156 14.132 1.99156 14C1.99156 13.868 2.0177 13.7373 2.06847 13.6154C2.11924 13.4936 2.19363 13.383 2.28736 13.29L13.2874 2.29C13.3808 2.19732 13.4916 2.12399 13.6135 2.07423C13.7353 2.02446 13.8658 1.99924 13.9974 2H20.6674C20.8 2 20.9271 2.05268 21.0209 2.14645C21.1147 2.24021 21.1674 2.36739 21.1674 2.5V9.17C21.1681 9.30161 21.1429 9.43207 21.0931 9.55391C21.0434 9.67574 20.97 9.78656 20.8774 9.88L20.7074 10.04C20.6795 10.0688 20.6587 10.1036 20.6466 10.1418C20.6345 10.18 20.6313 10.2204 20.6374 10.26C20.6429 10.2983 20.6577 10.3346 20.6803 10.3659C20.7029 10.3973 20.7328 10.4227 20.7674 10.44C21.2018 10.6748 21.6135 10.9493 21.9974 11.26C22.0436 11.3029 22.1043 11.3267 22.1674 11.3267C22.2304 11.3267 22.2911 11.3029 22.3374 11.26C22.8755 10.7101 23.1739 9.96939 23.1674 9.2V2C23.1674 1.46957 22.9566 0.960859 22.5816 0.585786C22.2065 0.210714 21.6978 0 21.1674 0L13.9974 0C13.202 0.000700208 12.4394 0.31723 11.8774 0.88L0.87736 11.88C0.315558 12.4425 0 13.205 0 14C0 14.795 0.315558 15.5575 0.87736 16.12L7.04736 22.29C7.60943 22.8528 8.37198 23.1693 9.16736 23.17C9.67371 23.1673 10.1716 23.0403 10.6174 22.8C10.648 22.7815 10.6745 22.7568 10.6951 22.7275C10.7158 22.6983 10.7301 22.6651 10.7374 22.63C10.752 22.5969 10.7595 22.5612 10.7595 22.525C10.7595 22.4888 10.752 22.4531 10.7374 22.42C10.4156 22.0401 10.1341 21.6279 9.89736 21.19Z"
          fill={fillColor}
        />
        <path
          d="M11 17.5C11 18.7856 11.3812 20.0423 12.0954 21.1112C12.8097 22.1801 13.8248 23.0132 15.0126 23.5052C16.2003 23.9972 17.5072 24.1259 18.7681 23.8751C20.029 23.6243 21.1872 23.0052 22.0962 22.0962C23.0052 21.1872 23.6243 20.029 23.8751 18.7681C24.1259 17.5072 23.9972 16.2003 23.5052 15.0126C23.0132 13.8248 22.1801 12.8097 21.1112 12.0954C20.0423 11.3812 18.7856 11 17.5 11C15.7769 11.0026 14.1251 11.6883 12.9067 12.9067C11.6883 14.1251 11.0026 15.7769 11 17.5ZM20 16.75C20.1989 16.75 20.3897 16.829 20.5303 16.9697C20.671 17.1103 20.75 17.3011 20.75 17.5C20.75 17.6989 20.671 17.8897 20.5303 18.0303C20.3897 18.171 20.1989 18.25 20 18.25H18.5C18.4337 18.25 18.3701 18.2763 18.3232 18.3232C18.2763 18.3701 18.25 18.4337 18.25 18.5V20C18.25 20.1989 18.171 20.3897 18.0303 20.5303C17.8897 20.671 17.6989 20.75 17.5 20.75C17.3011 20.75 17.1103 20.671 16.9697 20.5303C16.829 20.3897 16.75 20.1989 16.75 20V18.5C16.75 18.4337 16.7237 18.3701 16.6768 18.3232C16.6299 18.2763 16.5663 18.25 16.5 18.25H15C14.8011 18.25 14.6103 18.171 14.4697 18.0303C14.329 17.8897 14.25 17.6989 14.25 17.5C14.25 17.3011 14.329 17.1103 14.4697 16.9697C14.6103 16.829 14.8011 16.75 15 16.75H16.5C16.5663 16.75 16.6299 16.7237 16.6768 16.6768C16.7237 16.6299 16.75 16.5663 16.75 16.5V15C16.75 14.8011 16.829 14.6103 16.9697 14.4697C17.1103 14.329 17.3011 14.25 17.5 14.25C17.6989 14.25 17.8897 14.329 18.0303 14.4697C18.171 14.6103 18.25 14.8011 18.25 15V16.5C18.25 16.5663 18.2763 16.6299 18.3232 16.6768C18.3701 16.7237 18.4337 16.75 18.5 16.75H20Z"
          fill={fillColor}
        />
      </g>
    </svg>
  );
};

type EditRubricEditCategorySectionAddTagButtonProps = Pick<
  TouchTargetProps,
  'behavior'
> & {
  open: boolean;
};
const EditRubricEditCategorySectionAddTagButton: React.FC<
  EditRubricEditCategorySectionAddTagButtonProps
> = ({ behavior, open }) => {
  const language = useLanguage();
  return (
    <TertiaryButton
      label={language.editRubricCategoryCreationSectionAddTagsButtonLabel()}
      icon={<EditRubricEditCategorySectionAddTagButtonIcon />}
      behavior={behavior}
      className={cn('rounded-lg border-[2px] py-3 px-4 mr-4', {
        'border-indigo-200': !open,
        'border-indigo-300': open,
        'bg-gray-100': !open,
        'bg-indigo-200': open,
      })}
    />
  );
};

const EditRubricEditCategorySectionNameAndTags: React.FC<{
  gradingType: RubricGradingType;
  onRemoveTag: (tag: string) => void;
  onAddTag: (tag: string) => void;
  tags: string[];
  possibleTags: string[];
  label: string;
  onUpdateLabel: (label: string) => void;
  requiredLabelError: boolean;
  duplicateLabelError: boolean;
  duplicateLabelServerError: boolean;
}> = ({
  gradingType,
  onRemoveTag,
  tags,
  onAddTag,
  possibleTags,
  label,
  onUpdateLabel,
  requiredLabelError,
  duplicateLabelError,
  duplicateLabelServerError,
}) => {
  const language = useLanguage();
  const [touched, setTouched] = useState(false);

  const [addTagPopupAnchorEl, setAddTagPopupAnchorEl] =
    useState<null | HTMLAnchorElement>(null);
  const [addTagPopupOpen, setAddTagPopupOpen] = useState(false);
  const handleAddTagClick = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      setAddTagPopupAnchorEl(event.currentTarget);
      setAddTagPopupOpen((previousOpen) => !previousOpen);
    },
    [],
  );

  const handleAddTagPopupClosed = useCallback(() => {
    setAddTagPopupOpen(false);
  }, []);

  const allTags = useMemo(
    () => Array.from(new Set([...possibleTags, ...tags])),
    [possibleTags, tags],
  );

  return (
    <Spacing
      size="md"
      direction="vertical"
      className="rounded-2xl bg-gray-100 py-6 px-8"
    >
      <TextField
        variant="standard"
        size="small"
        required
        label={language.editRubricCategoryCreationSectionCategoryNameLabel({
          gradingType,
        })}
        placeholder={language.editRubricCategoryCreationSectionCategoryNamePlaceholder(
          { gradingType },
        )}
        value={label}
        error={
          touched &&
          (requiredLabelError ||
            duplicateLabelError ||
            duplicateLabelServerError)
        }
        helperText={
          requiredLabelError
            ? language.rubricCategoryLabelRequired({
                gradingType,
              })
            : duplicateLabelError || duplicateLabelServerError
              ? language.rubricCategoryLabelDuplicate({
                  gradingType,
                })
              : undefined
        }
        onChange={(e) => {
          if (!touched) setTouched(true);
          onUpdateLabel(e.currentTarget.value);
        }}
      />
      <Spacing
        direction="horizontal"
        size="sm"
        className="flex-wrap gap-y-4 items-center"
      >
        <EditRubricEditCategorySectionAddTagButton
          behavior={{
            type: 'onClick',
            onClick: handleAddTagClick,
          }}
          open={addTagPopupOpen}
        />

        <EditRubricTagsPopup
          anchorEl={addTagPopupAnchorEl}
          open={addTagPopupOpen}
          onClose={handleAddTagPopupClosed}
          tags={tags}
          onAddTag={onAddTag}
          onRemoveTag={onRemoveTag}
          possibleTags={allTags}
        />

        {tags.map((t) => (
          <RubricTagPill key={t} name={t} onRemove={() => onRemoveTag(t)} />
        ))}
      </Spacing>
    </Spacing>
  );
};

const EditRubricEditCategorySectionActionBar = ({
  onAddCriteria,
  onSave,
  onCancel,
  saveDisabled,
}: {
  onAddCriteria: () => void;
  onCancel: () => void;
  onSave: () => void;
  saveDisabled: boolean;
}) => {
  return (
    <Spacing
      size="md"
      direction="horizontal"
      className="rounded-2xl bg-gray-100 py-2 px-4 items-center justify-between"
    >
      <EditRubricAddCriteriaButton
        behavior={{
          type: 'onClick',
          onClick: () => {
            onAddCriteria();
          },
        }}
      />
      <Spacing size="md" direction="horizontal" className="py-1 px-4">
        <EditRubricCancelButton
          behavior={{
            type: 'onClick',
            onClick: () => {
              onCancel();
            },
          }}
        />
        <EditRubricSaveButton
          disabled={saveDisabled}
          behavior={{
            type: 'onClick',
            onClick: () => {
              onSave();
            },
          }}
        />
      </Spacing>
    </Spacing>
  );
};

export const EditRubricEditCategorySection: React.FC<{
  gradingType: RubricGradingType;
  onAddTag: (tag: string) => void;
  onRemoveTag: (tag: string) => void;
  tags: string[];
  possibleTags: string[];
  criteria: {
    text: string;
    weight: number;
  }[];
  onChangeWeight: (index: number, weight: number) => void;
  onChangeText: (index: number, text: string) => void;
  onAddCriteria: () => void;
  label: string;
  onChangeLabel: (label: string) => void;
  onSave: () => void;
  onCancel: () => void;
  onRemoveCriteria: (index: number) => void;
  duplicateLabelError: boolean;
  duplicateLabelServerError: boolean;
  requiredLabelError: boolean;
  requiredCriteriaErrors: number[];
}> = ({
  gradingType,
  onRemoveTag,
  possibleTags,
  onAddTag,
  tags,
  criteria,
  onChangeText,
  onChangeWeight,
  onAddCriteria,
  label,
  onChangeLabel,
  onSave,
  onCancel,
  onRemoveCriteria,
  requiredCriteriaErrors,
  requiredLabelError,
  duplicateLabelError,
  duplicateLabelServerError,
}) => {
  return (
    <EditRubricCard>
      <Spacing size="lg" direction="vertical">
        <EditRubricEditCategorySectionNameAndTags
          gradingType={gradingType}
          possibleTags={possibleTags}
          onAddTag={onAddTag}
          onRemoveTag={onRemoveTag}
          tags={tags}
          label={label}
          onUpdateLabel={onChangeLabel}
          requiredLabelError={requiredLabelError}
          duplicateLabelError={duplicateLabelError}
          duplicateLabelServerError={duplicateLabelServerError}
        />
        {criteria.map((criteria, criteriaIndex) => (
          <EditRubricEditCategorySectionCriteriaThread
            key={criteriaIndex}
            weight={criteria.weight}
            text={criteria.text}
            onChangeText={(text) => onChangeText(criteriaIndex, text)}
            onChangeWeight={(weight) => onChangeWeight(criteriaIndex, weight)}
            onRemove={() => onRemoveCriteria(criteriaIndex)}
            requiredCriteriaError={requiredCriteriaErrors.includes(
              criteriaIndex,
            )}
          />
        ))}
        <EditRubricEditCategorySectionActionBar
          onAddCriteria={onAddCriteria}
          onCancel={onCancel}
          onSave={onSave}
          saveDisabled={
            requiredCriteriaErrors.length > 0 ||
            requiredLabelError ||
            duplicateLabelError ||
            criteria.length === 0
          }
        />
      </Spacing>
    </EditRubricCard>
  );
};
